import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastService } from '@vsolv/vectors-ui/alert';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';
import { Claim } from '@wsphere/warranties/domain';
import { ClaimItemLineService } from '../../services';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-claim-item-line-remove-dialog',
  templateUrl: './claim-item-line-remove.dialog.html',
  standalone: false,
})
export class ClaimItemLineRemoveDialog {
  constructor(
    private lineSvc: ClaimItemLineService,
    private toastSvc: ToastService
  ) {}

  @ViewChild(DialogComponent) dialog?: DialogComponent;

  @Input() claim: Claim.Model | null = null;
  @Input() item: Claim.ClaimItem.Model | null = null;

  @Output() removed = new EventEmitter<string>();

  line: Claim.ClaimItem.Line.Model | null = null;
  removing = false;

  open(line: Claim.ClaimItem.Line.Model) {
    this.line = line;
    this.dialog?.open();
  }

  close() {
    this.dialog?.close();
  }

  formatAmount(amount: number) {
    return '$' + (amount / 100).toFixed(2);
  }

  async remove() {
    if (!this.claim || !this.item || !this.line || this.removing) return;

    this.removing = true;
    const removed = await this.lineSvc.remove(this.claim.id, this.item.id, this.line.id).catch(({ error }) => {
      this.toastSvc.show({ type: 'error', title: 'Something went wrong', text: error?.message });
      return null;
    });
    this.removing = false;

    if (removed) {
      this.toastSvc.show({ type: 'success', title: 'Charge Removed', text: 'Successfully removed the charge.' });
      this.removed.emit(removed.id);
      this.close();
    }
  }
}
